const US = {
  company: [
    "single-member LLC",
    "corporation (Corp.)",
    "incorporation (Inc.)"
  ],
  legalArrangement: [
    "limited liability partnership (LLP)",
    "limited liability limited partnership (LLLP)",
    "general partnership (GP)"
  ]
};
export {
  US as default
};
